// DepsContext.js
import React, {createContext, useContext} from 'react';
import {useSessionService} from "./SessionService";
import {useStore} from "react-redux";

const DepServicesContext = createContext({});

export function useDepServices() {
    return useContext(DepServicesContext);
}

export function DepServicesProvider({children, ...services}) {

    const sessionService = useSessionService();
    const store = useStore();

    for (const key in services) {
        services[key].setStore(store);
        services[key].setSessionService(sessionService);
    }

    return (
        <DepServicesContext.Provider value={services}>
            {children}
        </DepServicesContext.Provider>
    )
}
